<template>
  <a-modal
      title="Signaal details"
      :visible="visible"
      cancel-text="Sluiten"
      @cancel="handleClose"
      width="80%"
  >
    <template>

      <a-descriptions bordered size="small">
        <a-descriptions-item label="Omschrijving" :span="3">
          <div v-html="getSanitizedSignalDescription"></div>
        </a-descriptions-item>
        <a-descriptions-item label="Notitie" :span="3">
          {{ signal.comment }}
        </a-descriptions-item>
        <a-descriptions-item label="Datum">
          {{ dateFormatter(signal.created_at) }}
        </a-descriptions-item>
        <a-descriptions-item label="Klant">
          <CustomerBadgeComponent :customer="signal.customer.data" />
        </a-descriptions-item>
        <a-descriptions-item label="Status">
          {{ signal.status === SignalStatusEnum.ACTIVE ? 'Actief' : 'Verwerkt' }}
        </a-descriptions-item>
      </a-descriptions>
      <br />

      <a-descriptions bordered title="Communicatie klant" size="small">
        <a-descriptions-item label="Zichtbaar voor klant" :span="3">
          <span v-if="isVisibleForCustomer"><eye-icon class="icon-green"></eye-icon> Zichtbaar voor de klant</span>
          <span v-if="!isVisibleForCustomer"><eye-off-icon></eye-off-icon> Niet zichtbaar voor de klant</span>
        </a-descriptions-item>
        <a-descriptions-item label="Bericht aan klant" :span="3">
          <div v-html="getSanitizedCustomerMessage"></div>
        </a-descriptions-item>
      </a-descriptions>

    </template>

    <template slot="footer">
      <a-button @click="handleClose" type="primary">
        Sluiten
      </a-button>
    </template>

  </a-modal>
</template>

<script>
import { SignalStatusEnum } from "~/enums";
import { DateFormatEnum } from "~/enums";
import CustomerBadgeComponent from '~/modules/customer/components/BadgeComponent';
import DOMPurify from 'dompurify';

const moment = require('moment');

export default {
  name: "ShowSignalModalComponent",
  props: {
    signal: {
      type: Object,
      default: null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  components: {
    CustomerBadgeComponent
  },
  data() {
    return {
      SignalStatusEnum: SignalStatusEnum,
      DateFormatEnum: DateFormatEnum,
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    dateFormatter(date) {
      return moment(date, moment.ISO_8601).format(DateFormatEnum.DISPLAY_DATE);
    },
  },
  computed: {
    hasSignalQueryData() {
      return 'signal_query' in this.signal
          && 'data' in this.signal.signal_query
          && typeof this.signal.signal_query.data !== undefined;
    },
    getSanitizedCustomerMessage() {
      return this.hasSignalQueryData
      && 'customer_message' in this.signal.signal_query.data
      && this.signal.signal_query.data.customer_message !== null
      && this.signal.signal_query.data.customer_message.length > 0
          ? DOMPurify.sanitize(this.signal.signal_query.data.customer_message)
          : '';
    },
    isVisibleForCustomer() {
      return this.hasSignalQueryData
      && 'visible_for_customer' in this.signal.signal_query.data
      && this.signal.signal_query.data.visible_for_customer !== null
          ? this.signal.signal_query.data.visible_for_customer
          : false;
    },
    getSanitizedSignalDescription() {
      return DOMPurify.sanitize(this.signal.description);
    },
  },
}
</script>

<style scoped>
.icon-green {
  color: rgb(109, 194, 135);
}
</style>
